module.exports = __webpack_public_path__ + "static/media/YM82_3.cd6699ba.jpg";